var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages-control"},[_c('span',{staticClass:"nav-link"},[(_vm.item.count !== undefined)?_c('span',{staticClass:"nav-count-badge"},[_vm._v("\n            "+_vm._s(_vm.item.count)+"\n        ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }